<template>
  <div class="card">
    <div class="table-responsive">
      <table
        class="table table-sm table-bordered table-striped text-center"
        width="100%"
      >
        <thead class="bg-teal text-white">
          <tr>
            <th>Código</th>
            <th>Nome</th>
            <th>Ações</th>
          </tr>
        </thead>
        <tbody v-if="ccBloqueados.length > 0">
          <tr v-for="ccBloqueado in ccBloqueados" :key="ccBloqueado.id">
            <td>{{ ccBloqueado.codCCustoFilho }}</td>
            <td>{{ ccBloqueado.nomeCCustoFilho }}</td>
            <td>
              <button
                type="button"
                class="btn btn-sm btn-outline-danger btn-icon"
                title="Excluir"
                @click="$emit('deleteCCBloqueado', ccBloqueado.id)"
              >
                <i class="ph-trash"></i>
              </button>
            </td>
          </tr>
        </tbody>
        <tbody v-else>
          <tr>
            <td colspan="3" class="text-center">
              Nenhum centro de custo cadastrado como bloqueado
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ListCCBloqueados',

  props: {
    ccBloqueados: {
      type: Array,
      required: true,
    },
  },
}
</script>
